export const PASSWORD_RULE = {
    length: {
        from: 6,
        to: 30,
    },
};
